import styled from 'styled-components'

export const CheckoutWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  padding: 0 var(--view-padding-horizontal);
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
`

export const CheckoutLogo = styled.div`
  flex: 0 0 auto;
  padding: 3vh 0 1.5vh 0;
  align-self: center;
  svg {
    height: 3rem;
    margin: 0 auto;
    display: block;
  }

  img {
    height: 3rem;
    margin: 0 auto;
    display: block;
  }
`

export const CheckoutBody = styled.div`
  position: relative;
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`

export const CheckoutProvider = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 0.85rem;
  padding: 1rem 0 1.5rem 0;
  color: var(--color-muted);

  img {
    height: 1.8rem;
    margin-top: 0.5rem;
    cursor: pointer;
  }
`
